// Event detail page (CHG-1254 / ITER-3379).
//
// Thin per v2-canary: configuration in @generated/screens. Future
// generator regenerates eventDetailConfig from event.entity-hint.yaml.
//
// Spec: specs/tier-05-experience/event-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { eventDetailConfig } from "../generated/screens/event-detail";

export function EventDetail() {
  return <DetailPage config={eventDetailConfig} />;
}
